import { memo } from 'react';
import { ScrollArea } from '@/components/ui/scroll-area';
import { IContextSidebarProps } from '@/@types/layout';
import { SidebarSectionMemo } from './SidebarSection';

function ContextSidebar({ sections }: IContextSidebarProps) {
  return (
    <aside className="w-52 bg-sidebar border-r border-sidebar-border h-full shrink-0">
      <ScrollArea className="h-full">
        <div className="p-3 space-y-5">
          {sections.map((section) => (
            <SidebarSectionMemo
              key={section.id}
              title={section.title}
              items={section.items}
            />
          ))}
        </div>
      </ScrollArea>
    </aside>
  );
}

export const ContextSidebarMemo = memo(ContextSidebar);
